module.exports = __webpack_public_path__ + "img/sec_in2.b12254db.jpg";